import { toDateKey } from '@/components/calendar/calendar-utils';
import type { OfferingType } from '@/services/offering';

export const OFFERING_LINKS = {
  classes: { href: '/classes', illustration: 'single-class-3d' },
  subscriptions: { href: '/subscriptions', illustration: 'subscription-3d' },
  classPacks: { href: '/packages', illustration: 'class-pack-3d' },
} as const;

export const DETAIL_PATH: Record<OfferingType, string> = {
  class: OFFERING_LINKS.classes.href,
  pack: OFFERING_LINKS.classPacks.href,
  subscription: OFFERING_LINKS.subscriptions.href,
  gift_card: '/gift-cards',
};

export const detailPath = (type: OfferingType, slug: string) =>
  `${DETAIL_PATH[type]}/${slug}`;

// The class page opens on the day `?date=` names, written the way the page
// writes it back itself.
export const classDatePath = (slug: string, startTime: string | number) =>
  `${detailPath('class', slug)}?date=${toDateKey(new Date(startTime))}`;

export const COVERS_CLASS_PARAM = 'class_id';

export const listCoveringClassPath = (
  list: 'classPacks' | 'subscriptions',
  classId: string
) =>
  `${OFFERING_LINKS[list].href}?${COVERS_CLASS_PARAM}=${encodeURIComponent(classId)}`;
